const GENRE_COLORS: Record<string, string> = {
  sports: "var(--g-sports)",
  news: "var(--g-news)",
  movie: "var(--g-movies)",
  movies: "var(--g-movies)",
  series: "var(--g-series)",
  kids: "var(--g-kids)",
  children: "var(--g-kids)",
  documentary: "var(--g-docs)",
  docs: "var(--g-docs)",
  music: "var(--g-music)",
};

const DEFAULT_COLOR = "var(--g-other)";

export function genreColor(genre?: string): string {
  if (!genre) return DEFAULT_COLOR;
  const key = genre.toLowerCase().trim();
  return GENRE_COLORS[key] ?? DEFAULT_COLOR;
}
